import { Component } from "react";

// Muestra `fallback` si un hijo falla al renderizar, por ejemplo un <Canvas> 3D en un equipo sin WebGL.
export default class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
